import { render } from "./GroupCustSelect.vue?vue&type=template&id=68d7febe&ts=true"
import script from "./GroupCustSelect.vue?vue&type=script&lang=ts"
export * from "./GroupCustSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__